import { render } from "./MetricsPage.vue?vue&type=template&id=0ee1fc06"
import script from "./MetricsPage.vue?vue&type=script&lang=js"
export * from "./MetricsPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__